import React, { FC } from 'react';
import {
  DashboardContainer,
  ContainerContent,
  DashboardContainerHeader,
  DashboardContainerBody,
  H3,
} from '../MoaDashboard.styles';
import { PricingMetricsProps } from './PricingMetrics.types';
import { ThemeProvider } from '@mui/material/styles';
import { Drawer, Divider } from '@mui/material';
import MenuTreeView from '../../../components/MenuTreeView/MenuTreeView';
import { TreeViewWrapper, StyledHeader, DrawerHeader, ExportButtonWrapper } from './PricingMetrics.style';
import { StyledHeaderTitle } from '../../../components/Table/Table.styles';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { CSVLink } from 'react-csv';
import { Variant } from '../../../components/Button/Button.types';
import Button from '../../../components/Button/Button';
import { usePricingMetrics } from './usePricingMetrics';
import EventCount from "../EventCount";

const PricingMetrics: FC<PricingMetricsProps> = ({
  pricingMetrics,
  bundlePricingMetrics,
  from,
  to,
  isDashboardLoading,
}) => {
  const {
    openDrawer,
    toggleDrawer,
    defineDrawer,
    muiTheme,
    isLoading,
    isBundleLoading,
    availableOrganizations,
    availableBundleOrganizations,
    dataStructure,
    bundleDataStructure,
    expandedRows,
    bundleExpandedRows,
    handleRowClick,
    handleBundleRowClick,
    columnDefs,
    bundleColumnDefs,
    extractDataFromPayload,
    extractBundleDataFromPayload,    formattedDate,
    activePricingTab,
  } = usePricingMetrics({ from, to });
  return (
    <>
      <DashboardContainer style={{ width: '85%' }} data-testid={'pricingContainer'}>
        <DashboardContainerHeader style={{ display: 'flex', alignItems: 'center' }}>
          Pricing Metrics
          {(pricingMetrics?.menus !== 0 || bundlePricingMetrics?.menus !== 0) && !isDashboardLoading && (
            <H3
              style={{ paddingRight: '1rem', marginLeft: 'auto' }}
              dataTestId='seePricingDetails'
              label={'See details'}
              onClick={() => defineDrawer('99pricing')}
              to={''}
            ></H3>
          )}
        </DashboardContainerHeader>
        <DashboardContainerBody>
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <div style={{ display: 'flex', flexDirection: 'column', width: '48%' }}>
              <ContainerContent style={{ position: 'relative', display: 'flex' }}>
                <EventCount
                    label={'Menus'}
                    count={pricingMetrics?.menus}
                    isLoading={isDashboardLoading}
                    testId={'pricingCounter'}
                />
              </ContainerContent>
              <div style={{ marginTop: '8px', paddingRight: '1rem' }}>
                <h4 style={{ margin: 0, fontFamily: 'Open Sans', fontSize: '14px' }}>$99.99 Pricing</h4>
              </div>
            </div>

            <ThemeProvider theme={muiTheme}>
              <div style={{ display: 'flex', alignItems: 'center', padding: '0 16px' }}>
                <Divider orientation='vertical' flexItem />
              </div>
            </ThemeProvider>

            <div style={{ display: 'flex', flexDirection: 'column', width: '48%' }}>
              <ContainerContent style={{ position: 'relative', display: 'flex' }}>
                <EventCount
                    label={'Stores'}
                    count={bundlePricingMetrics?.menus}
                    isLoading={isDashboardLoading}
                />
              </ContainerContent>
              <div style={{ marginTop: '8px', paddingRight: '1rem' }}>
                <h4 style={{ margin: 0, fontFamily: 'Open Sans', fontSize: '16px' }}>Bundle $99 Pricing</h4>
              </div>
            </div>
          </div>
        </DashboardContainerBody>
      </DashboardContainer>{' '}
      <ThemeProvider theme={muiTheme} key={'drawer-mui-theme'}>
        <Drawer
          PaperProps={{
            sx: { width: '45%' },
          }}
          anchor={'right'}
          open={openDrawer}
          onClose={() => toggleDrawer(false)}
        >
          <DrawerHeader data-testid='drawerHeader'>
            {activePricingTab === '99pricing' ? '$99.99 Prices' : 'Bundle Pricing'}
            <CloseOutlinedIcon
              onClick={() => toggleDrawer(false)}
              style={{ paddingLeft: '1rem', display: 'flex', alignItems: 'flex-end' }}
            />
          </DrawerHeader>

          {/* Conditional rendering based on active tab */}
          {activePricingTab === '99pricing' ? (
            <>
              <TreeViewWrapper>
                <StyledHeader data-testid='header'>
                  <StyledHeaderTitle>Menu $99 Pricing</StyledHeaderTitle>
                </StyledHeader>
                <MenuTreeView
                  rows={availableOrganizations}
                  dataStructure={dataStructure}
                  expandedRows={expandedRows}
                  onRowClick={handleRowClick}
                  isLoading={isLoading}
                />
              </TreeViewWrapper>
              <ExportButtonWrapper style={{ paddingTop: '10px', paddingRight: '30px', paddingBottom: '20px' }}>
                <CSVLink
                  data={extractDataFromPayload(availableOrganizations)}
                  headers={columnDefs}
                  filename={`99_Pricing_Metrics_${formattedDate}.csv`}
                  target='_blank'
                  className='btn btn-primary'
                  style={{ textDecoration: 'none', color: 'inherit' }}
                >
                  <Button testId='export99CSV' label='Export Menus 99 Pricing to CSV' variant={Variant.Secondary} />
                </CSVLink>              </ExportButtonWrapper>
              
              <ThemeProvider theme={muiTheme}>
                <div style={{ padding: '0 16px', margin: '10px 0' }}>
                  <Divider flexItem />
                </div>
              </ThemeProvider>

              <TreeViewWrapper>
                <StyledHeader data-testid='bundleHeader'>
                  <StyledHeaderTitle>Bundle $99 Pricing</StyledHeaderTitle>
                </StyledHeader>                <MenuTreeView
                  rows={availableBundleOrganizations}
                  dataStructure={bundleDataStructure}
                  expandedRows={bundleExpandedRows}
                  onRowClick={handleBundleRowClick}
                  isLoading={isBundleLoading}
                  noRowsMessage=""
                />
              </TreeViewWrapper>
              <ExportButtonWrapper style={{ paddingTop: '10px', paddingRight: '30px', paddingBottom: '30px' }}>
                <CSVLink
                  data={extractBundleDataFromPayload(availableBundleOrganizations)}
                  headers={bundleColumnDefs}
                  filename={`Bundle_Pricing_Metrics_${formattedDate}.csv`}
                  target='_blank'
                  className='btn btn-primary'
                  style={{ textDecoration: 'none', color: 'inherit' }}
                >
                  <Button
                    testId='exportBundleCSV'
                    label='Export Menu Bundle Pricing to CSV'
                    variant={Variant.Secondary}
                  />
                </CSVLink>
              </ExportButtonWrapper>
            </>
          ) : (
            <>
              <TreeViewWrapper>
                <StyledHeader data-testid='bundleHeader'>
                  <StyledHeaderTitle>Bundle Pricing - FZ Code</StyledHeaderTitle>
                </StyledHeader>                <MenuTreeView
                  height={'40%'}
                  rows={availableBundleOrganizations}
                  dataStructure={bundleDataStructure}
                  expandedRows={bundleExpandedRows}
                  onRowClick={handleBundleRowClick}
                  isLoading={isBundleLoading}
                  noRowsMessage=""
                />
              </TreeViewWrapper>
              <ExportButtonWrapper style={{ paddingTop: '20px', paddingRight: '30px', paddingBottom: '20px' }}>
                <CSVLink
                  data={extractBundleDataFromPayload(availableBundleOrganizations)}
                  headers={bundleColumnDefs}
                  filename={`Bundle_Pricing_Metrics_${formattedDate}.csv`}
                  target='_blank'
                  className='btn btn-primary'
                  style={{ textDecoration: 'none', color: 'inherit' }}
                >
                  <Button
                    testId='exportBundleCSV'
                    label='Export Menu Bundle Pricing to CSV'
                    variant={Variant.Secondary}
                  />
                </CSVLink>              </ExportButtonWrapper>
              
              <ThemeProvider theme={muiTheme}>
                <div style={{ padding: '0 16px', margin: '10px 0' }}>
                  <Divider flexItem />
                </div>
              </ThemeProvider>

              <TreeViewWrapper>
                <StyledHeader data-testid='header'>
                  <StyledHeaderTitle>$99.99 Pricing - FZ Code</StyledHeaderTitle>
                </StyledHeader>
                <MenuTreeView
                  height={'40%'}
                  rows={availableOrganizations}
                  dataStructure={dataStructure}
                  expandedRows={expandedRows}
                  onRowClick={handleRowClick}
                  isLoading={isLoading}
                />
              </TreeViewWrapper>
              <ExportButtonWrapper style={{ paddingTop: '20px', paddingRight: '30px', paddingBottom: '30px' }}>
                <CSVLink
                  data={extractDataFromPayload(availableOrganizations)}
                  headers={columnDefs}
                  filename={`99_Pricing_Metrics_${formattedDate}.csv`}
                  target='_blank'
                  className='btn btn-primary'
                  style={{ textDecoration: 'none', color: 'inherit' }}
                >
                  <Button testId='export99CSV' label='Export Menus 99 Pricing to CSV' variant={Variant.Secondary} />
                </CSVLink>
              </ExportButtonWrapper>
            </>
          )}
        </Drawer>
      </ThemeProvider>
    </>
  );
};

export default PricingMetrics;